import Carousel from 'shared/carousel/carousel'

export default class SelectedArticles {
	private selectedArticlesWrapper: NodeListOf<Element>

	constructor() {
		this.selectedArticlesWrapper = document.querySelectorAll('.selectedArticles-carousel')

		this.initCarousel = this.initCarousel.bind(this)
	}

	init() {
		if (!this.selectedArticlesWrapper) return

		for (const carousel of this.selectedArticlesWrapper) {
			this.initCarousel(carousel as HTMLElement)
		}
	}

	initCarousel(carousel: HTMLElement) {
		const peopleCarousel = new Carousel({
			element: carousel,
			itemsToScrollBy: 2
		})

		peopleCarousel.init()
	}
}
